import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPlausiblePageView } from '../utils/plausible';

/** Fire Plausible pageview on SPA route changes (initial load handled in ensurePlausibleInit). */
export default function usePlausible() {
  const { pathname, search } = useLocation();
  const skipInitial = useRef(true);

  useEffect(() => {
    if (skipInitial.current) {
      skipInitial.current = false;
      return;
    }
    trackPlausiblePageView();
  }, [pathname, search]);
}
